import { Form, FormItemProps } from 'antd';
import React from 'react';

interface FormList extends FormItemProps {
  actionRow?: React.ReactElement;
}

export default function FormList({ children, name, actionRow }: FormList) {
  return (
    <Form.List name={name}>
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name: _name, ...restField }) =>
            React.cloneElement(children as React.ReactElement, {
              remove,
              key: key,
              rootName: _name,
              ...restField,
            }),
          )}
          {!!actionRow &&
            React.cloneElement(actionRow, {
              add,
            })}
        </>
      )}
    </Form.List>
  );
}
